// hooks/use-feedback.ts
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useGetAllFeedback } from '../../../apis/feedback/get-all-feedback';
import { useGetUnreadCounts } from '../../../apis/feedback/use-get-unread-counts';
import { useUpdateFeedbackStatus } from '../../../apis/feedback/update-feedback-status';
import { IGetAllFeedbackDataDocs } from '../../../utils/types';

const useFeedback = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [loadingRow, setLoadingRow] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const app = (searchParams.get("app") || "user") as "user" | "driver";

    const { data: feedbackData, isFetching: loading, refetch: refetchFeedback } = useGetAllFeedback({
        limit: 10,
        userType: app,
        page: currentPage,
    });

    const { data: unreadCount, refetch: refetchUnreadCounts } = useGetUnreadCounts();

    const { mutateAsync: updateStatus } = useUpdateFeedbackStatus();

    const feedbacks = feedbackData?.docs ?? [];
    const totalPages = feedbackData?.totalPages ?? 1;

    const handleAppChange = (newApp: string) => {
        setSearchParams((prev) => {
            prev.set("app", newApp);
            prev.set("page", "1");
            return prev;
        });
        setCurrentPage(1);
    };

    const handleUpdateFeedbackStatus = async (item: IGetAllFeedbackDataDocs) => {
        if (!item?._id) return;
        setLoadingRow(item._id);
        const newStatus = item.status === "read" ? "unread" : "read";
        await updateStatus({ feedbackId: item._id, status: newStatus });
        refetchFeedback();
        refetchUnreadCounts();
        setLoadingRow("");
    };

    return {
        app,
        feedbacks,
        totalPages,
        loading,
        loadingRow,
        currentPage,
        setCurrentPage,
        unreadCount: unreadCount ?? { user: 0, driver: 0 },
        handleAppChange,
        handleUpdateFeedbackStatus,
    };
};

export default useFeedback;